<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-baoming"></i>
      {{ id ? '考试编辑' : '考试新增' }}
    </div>
    <div class="padding-sm">
      <el-form :model="examForm" :rules="rules" ref="examForm" label-width="120px">
        <el-form-item label="科目" prop="subject_first">
          <el-select v-model="examForm.subject_first" placeholder="请选择科目" style="width: 100%" :disabled="release">
            <el-option v-for="item in subjects" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试名称" prop="name">
          <el-input v-model="examForm.name" placeholder="请输入考试名称"></el-input>
        </el-form-item>
        <el-form-item label="考试类型" prop="paper_type" >
          <el-select v-model="examForm.paper_type" placeholder="请选择考试类型" style="width: 100%" :disabled="release">
            <el-option
                v-for="item in paper"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="考试费用" prop="fee">
          <el-input type="number" v-model="examForm.fee" placeholder="请输入考试费用"></el-input>
        </el-form-item>
        <el-form-item label="考试时间" prop="time">
          <el-date-picker
              style="width: 100%"
              v-model="examForm.time"
              :picker-options="pickerOptions"
              type="datetimerange"
              range-separator="至"
              start-placeholder="请选择考试开始日期"
              end-placeholder="请选择考试结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="报名截止时间" prop="enroll_end_time">
          <el-date-picker
              style="width: 100%"
              v-model="examForm.enroll_end_time"
              :picker-options="pickerOptions"
              type="datetime"
              placeholder="请选择报名截止时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="考试详情" prop="content">
          <VueUditorWrap v-model="examForm.content" :config="myConfig"></VueUditorWrap>
        </el-form-item>
        <el-form-item label="考生报名表" prop="student_enroll_id">
          <el-select v-model="examForm.student_enroll_id" placeholder="请选择考生报名表" style="width: 100%" :disabled="release">
            <el-option v-for="item in signList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl submit-btn" type="primary" @click="submitForm('examForm')">提交</el-button>
        </el-form-item>
      </el-form>

    </div>

  </div>
</template>

<script>
import {addExam, examEnrollList, examSubject, getExam} from "@/api/projectOffice";
import VueUditorWrap from "vue-ueditor-wrap";
import {bdEditConfig, paper,optionList} from "@/tools/utils";
export default {
  name: "examEdit",
  data() {
    return {
      id: '',
      release:0,
      paper:optionList(false,paper),
      subjects: [],
      signList: [],
      examForm: {
        subject_first: '',
        name: '',
        fee: '',
        time: null,
        paper_type:'',
        enroll_end_time: null,
        content: '',
        student_enroll_id: ''
      },
      rules: {
        subject_first: [{required: true, message: '请选择科目', trigger: 'change'}],
        name: [{required: true, message: '请输入考试名称', trigger: 'blur'},],
        paper_type: [{required: true, message: '请选择考试类型', trigger: 'change'},],
        fee: [{required: true, message: '请输入考试费用', trigger: 'blur'},],
        time: [{required: true, message: '请选择考试日期', trigger: 'change'}],
        enroll_end_time: [{type: 'date', required: true, message: '请选择报名截止时间', trigger: 'change'}],
        content: [{required: true, message: '请输入考试详情', trigger: 'blur'},],
        student_enroll_id: [{required: true, message: '请选择考生报名表', trigger: 'change'}],
      },
      pickerOptions: {
        disabledDate(time) {
          console.log(time)
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      myConfig: bdEditConfig()
    };
  },
  components: {VueUditorWrap},
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/examination',
        "当前位置：考试管理 > 考试编辑",
        true
    );
    this.id = this.$route.query.id
    this.init()
    if (this.id) this.getDetail();
  },

  methods: {
    async init() {
      let _list = await examSubject(
          1,
          10000,
          1,
          1
      );
      let _list2 = await examEnrollList(
          1,
          10000,
          1,
      );
      this.subjects = _list.data.list;
      this.signList = _list2.data.list;
    },
    async getDetail() {
      let _data = await getExam(this.id)
      this.release = _data.data.release
      this.examForm = {
        name:_data.data.name,
        subject_first:_data.data.subject_first,
        paper_type:_data.data.paper_type,
        time:[new Date(_data.data.exam_start_time*1000),new Date(_data.data.exam_end_time*1000)],
        fee:_data.data.fee,
        enroll_end_time:new Date(_data.data.enroll_end_time),
        content:_data.data.content,
        student_enroll_id:_data.data.student_enroll_id,
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _data = await addExam(
          this.examForm.name,
          this.examForm.subject_first,
          '',
          this.$tools.ZHDate(new Date(this.examForm.time[0]), 3),
          this.$tools.ZHDate(new Date(this.examForm.time[1]), 3),
          this.examForm.fee,
          this.$tools.ZHDate(new Date(this.examForm.enroll_end_time), 3),
          this.examForm.content,
          this.examForm.student_enroll_id,
          '',
          '',
          this.examForm.paper_type,
          this.id ? this.id : '',
      );
      this.$message.success(_data.msg);
      this.$router.go(-1)
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.table-item {
  p {
    span {
      color: #e4396c;
    }
  }

  input {
    display: block;
    height: 40px;
    padding: 0 10px;
    border: 1px solid #eee;
    margin-left: 10px;
  }

  input.radio {
    margin: 0;
  }

  textarea {
    display: block;
    border: 1px solid #eee;
    height: 60px;
    padding: 0 10px;
    margin-left: 10px;
  }
}
</style>
